const navLinksOther = [
  {
    icon: "fa-solid fa-headset",
    title: "Support",
    children: [
      {
        title: "Add Department",
        icon: "ri-arrow-right-s-fill",
        path: "/add-department",
      },
      
    ],
  },

  {
    icon: "fa-sharp fa-solid fa-gear",
    title: "Settings",
    children: [
      {
        title: "Roll Management",
        icon: "ri-arrow-right-s-fill",
        path: "/rolemanagement",
      },
      {
        title: "Permission Management",
        icon: "ri-arrow-right-s-fill",
        path: "/permissionmanagement",
      },
    ],
  },
];

export default navLinksOther;
